import { clientApi } from 'api';
import { IUser } from 'client/models/IUser';

export const userByToken = (isServer = false) => async () => {
  const response = await clientApi.get<IUser>('/users/by-token');

  return response.data;
};
